<template>
  <div>
    <form-loader v-if="loading"/>
    <template v-if="!loading">
      <p v-if="this.skin.oosztaan">
        Wonen bij WOV kent twee soorten inschrijvingen: Leden en Woningzoekenden. De inschrijfkosten voor een lid zijn eenmalig 20 EUR en daarna ieder jaar 7 EUR. De inschrijfkosten voor een woningzoekende zijn
        eenmalig 27 EUR en daarna ieder jaar 7 EUR. Woningzoekenden en leden hebben dezelfde rechten en mogen op dezelfde woningen reageren.<br/>
        U kunt alleen lid worden als u ooit in Oostzaan gewoond heeft of daar nu woont.
      </p>
      <p v-if="this.skin.oosztaan && summary.person.member === null">
        Uw aanvraag is in behandeling. Aan de hand van uw uitreksel BRP bepaalt WOV of u een lid of woningzoekende bent. Hierna ontvangt u een betaalverzoek.
      </p>

      <h2>Uw gezin bestaat uit</h2>
      <disabled-input-row label="U bent" :value="fullName(summary.person)"/>
      <b-row>
        <b-col sm="5" class="form-label">
          <i class="fad fax fa-user-circle"></i>
          <label>Inschrijfnummer</label>
        </b-col>
        <b-col sm="6">
          <b-form-input
                  size="sm"
                  :disabled="true"
                  v-model="summary.person.registrationnumber"
          />
        </b-col>
      </b-row>
      <b-row v-if="this.skin.oosztaan">
        <b-col sm="5" class="form-label">
          <i class="fad fax fa-user-circle"></i>
          <label>Lid van de WOV</label>
        </b-col>
        <b-col sm="6">
          <b-form-input
              size="sm"
              :disabled="true"
              :value="(summary.person.member === null) ? `Aanvraag in behandeling` : ((summary.person.member) ? 'Ja' : 'Nee')"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="5" class="form-label">
          <i class="fad fax fa-calendar-star"></i>
          <label for="dob">{{ skin.rightsName }}</label>
        </b-col>
        <b-col sm="6">
          <b-form-input
                  id="dob"
                  size="sm"
                  :value="dutchDate(summary.person.searchdate)"
                  disabled
                  placeholder=""
          />
        </b-col>
      </b-row>
      <b-row v-if="skin.searchpoints">
        <b-col sm="5" class="form-label">
          <i class="fad fax fa-award"></i>
          <label for="dob">Zoekpunten</label>
        </b-col>
        <b-col sm="6">
          <b-form-input
                  id="dob"
                  size="sm"
                  :value="summary.person.searchpoints"
                  disabled
                  placeholder=""
          />
        </b-col>
      </b-row>

      <b-row v-if=" this.skin.renewal && summary.person.renewaldate.length">
        <b-col sm="5" class="form-label">
          <i class="fad fax fa-award"></i>
          <label for="dob">Betaald tot</label>
        </b-col>
        <b-col sm="6">
          <b-form-input
                  id="renewaldate"
                  size="sm"
                  :value="dutchDate(summary.person.renewaldate)"
                  disabled
                  placeholder=""
          />
        </b-col>
      </b-row>

      <disabled-input-row label="Uw partner is" :value="summary.partner.registrationnumber.length ? fullName(summary.partner) : 'Geen Partner'"/>
      <b-row v-if="summary.partner.registrationnumber.length">
        <b-col sm="5" class="form-label">
          <i class="fad fax fa-user-circle"></i>
          <label>Inschrijfnummer partner</label>
        </b-col>
        <b-col sm="6">
          <b-form-input
                  size="sm"
                  :disabled="true"
                  v-model="summary.partner.registrationnumber"
          />
        </b-col>
      </b-row>
      <b-row v-if="this.skin.oosztaan && summary.partner.registrationnumber.length">
        <b-col sm="5" class="form-label">
          <i class="fad fax fa-user-circle"></i>
          <label>Lid van de WOV</label>
        </b-col>
        <b-col sm="6">
          <b-form-input
              size="sm"
              :disabled="true"
              :value="(summary.partner.member === null) ? `Aanvraag in behandeling` : ((summary.partner.member) ? 'Ja' : 'Nee')"
          />
        </b-col>
      </b-row>
      <b-row v-if="summary.partner.registrationnumber.length">
        <b-col sm="5" class="form-label">
          <i class="fad fax fa-calendar-star"></i>
          <label for="dob">{{ skin.rightsName }} partner</label>
        </b-col>
        <b-col sm="6">
          <b-form-input
                  id="dob"
                  size="sm"
                  :value="dutchDate(summary.partner.searchdate)"
                  disabled
                  placeholder=""
          />
        </b-col>
      </b-row>
      <b-row v-if="summary.partner.registrationnumber.length && skin.searchpoints">
        <b-col sm="5" class="form-label">
          <i class="fad fax fa-award"></i>
          <label for="dob">Zoekpunten partner</label>
        </b-col>
        <b-col sm="6">
          <b-form-input
                  id="dob"
                  size="sm"
                  :value="summary.partner.searchpoints"
                  disabled
                  placeholder=""
          />
        </b-col>
      </b-row>

      <b-row v-if="this.skin.renewal && summary.partner.renewaldate.length">
        <b-col sm="5" class="form-label">
          <i class="fad fax fa-award"></i>
          <label for="dob">Betaald tot</label>
        </b-col>
        <b-col sm="6">
          <b-form-input
              id="renewaldate"
              size="sm"
              :value="dutchDate(summary.partner.renewaldate)"
              disabled
              placeholder=""
          />
        </b-col>
      </b-row>

      <summary-extra-people-line :people="childrenUnder23" label="Kind" label-plural="Kinderen"
                                 v-if="childrenUnder23.length">
        <span class="under23">onder</span> de 23 jaar
      </summary-extra-people-line>

      <summary-extra-people-line :people="childrenOver23" label="Kind" label-plural="Kinderen"
                                 v-if="childrenOver23.length">
        <span class="over23">boven</span> de 23 jaar
      </summary-extra-people-line>

      <summary-extra-people-line :people="parents" label="Ouder" label-plural="Ouders" v-if="parents.length"
                                 icon="fa fa-tag">
        ten opzichte van u of uw partner
      </summary-extra-people-line>

      <summary-extra-people-line :people="otherPeople" label="Overige bewoner" label-plural="Overige bewoners"
                                 v-if="otherPeople.length"  icon="fa fa-tag"/>
      <b-row>
        <b-col sm="12" class="spacer d-none d-sm-block">&nbsp;</b-col>
      </b-row>
      <h2>U woont nu</h2>
      <disabled-input-row icon="fa fax fa-globe" label="U woont nu in" value="Nederland"/>
      <disabled-input-row icon="fa fax fa-map-marker" label="Postcode" :value="summary.address.zipcode"/>
      <disabled-input-row icon="fa fax fa-search-location" label="Huisnummer" :value="summary.address.housenumber"/>
      <disabled-input-row icon="fa fax fa-road" label="Straat" :value="summary.address.street"/>
      <disabled-input-row icon="fa fax fa-city" label="Woonplaats" :value="summary.address.city"/>
      <b-row>
        <b-col sm="12" class="spacer d-none d-sm-block">&nbsp;</b-col>
      </b-row>
      <h2>Uw inkomen is</h2>
      <disabled-input-row icon="fad fax fa-wallet" label="Inkomen van u samen" :value="summary.grossincome"/>

      <br>

      <h2>Uw overzicht</h2>

      <summary-message-box
              title="Huurmogelijkheden op basis van inkomen en huishouden"
              :message="`U kunt woningen huren met een huur per maand ${summary.situation.advice.maxrent}`"
              :collapsable="true"
              icon="fad fax fa-exclamation-circle"
      >
        Op grond van wettelijke normen kunt u op basis van uw inkomen en de grootte van uw huishouden woningen huren met een huur per maand {{ summary.situation.advice.maxrent }}
      </summary-message-box>

      <summary-message-box
              title="U bent doorstromer!"
              icon="fad fax fa-check-square"
              :collapsable="true"
              v-if="skin.doorstromer && summary.situation.doorstromer.show && summary.situation.doorstromer.status"
      >
        U krijgt bij advertenties met het label Doorstromers voorrang ten opzichte van andere woningzoekenden.
      </summary-message-box>

      <summary-message-box
              title="U bent geen doorstromer"
              icon="fad fax fa-info-circle"
              iconColor="#666666"
              :collapsable="true"
              v-if="skin.doorstromer && summary.situation.doorstromer.show && !summary.situation.doorstromer.status"
      >
        Uit de gegevens die u heeft ingevuld bij uw inschrijving blijkt dat u geen doorstromer bent.
      </summary-message-box>

      <summary-message-box
              title="U bent spoedzoeker!"
              :collapsable="true"
              v-if="summary.situation.spoedzoeker.show && summary.situation.spoedzoeker.status"
      >
        U bent spoedzoeker en kunt reageren op speciaal aanbod voor spoedzoekers.
      </summary-message-box>

      <summary-message-box
              title="U bent geen spoedzoeker"
              icon="fad fax fa-info-circle"
              iconColor="#666666"
              :collapsable="true"
              v-if="summary.situation.spoedzoeker.show && !summary.situation.spoedzoeker.status"
      >
        Uit de gegevens die u heeft ingevuld bij uw inschrijving blijkt dat u geen spoedzoeker bent. Via <a href="../temp_spoedzoeker">dit formulier</a> kunt u de status spoedzoeker aanvragen.
      </summary-message-box>

      <summary-message-box
          title="Inschrijfgeld is betaald"
          :collapsable="false"
          v-if="summary.situation.payment.show && summary.situation.payment.complete && summary.situation.payment.recurring"
          autoIncassoButton="true"
      >
        U betaald uw inschrijfgeld via automatische incasso.
      </summary-message-box>

      <summary-message-box
              title="Inschrijfgeld is betaald"
              :collapsable="true"
              v-if="summary.situation.payment.show && summary.situation.payment.complete && !summary.situation.payment.canpay && !summary.situation.payment.recurring"
      >
        U hebt uw inschrijfgeld betaald. Rond snel uw inschrijving af en dan kunt u op zoek naar een woning.
      </summary-message-box>

      <summary-message-box
          title="U kunt uw verlenging betalen"
          :collapsable="true"
          v-if="summary.situation.payment.show && summary.situation.payment.complete && summary.situation.payment.canpay && !summary.situation.payment.recurring"
      >
        U hebt uw inschrijfgeld al eens betaald, maar moet binnenkort verlengen. Het maakt niet uit op welk moment u uw verlenging betaald, er wordt altijd een jaar bij uw vorige betaaldatum opgeteld. <a href="/profiel/gegevens?step=Payment">Klik hier om uw verlenging te betalen.</a>
      </summary-message-box>

      <summary-message-box
              title="Inschrijfgeld is nog niet betaald"
              :collapsable="true"
              v-if="summary.situation.payment.show && !summary.situation.payment.complete && !summary.situation.payment.recurring"
      >
        U dient uw inschrijfgeld nog te betalen. Pas wanneer de betaling is ontvangen, kunt u reageren op woningen.
      </summary-message-box> 

      <br>
      <FormButtons @next="$emit('next')" @previous="$emit('previous')"/>
    </template>
  </div>
</template>

<script>
import FormButtons from '@/components/_registration/FormButtons'
import FormLoader from '@/components/_registration/FormLoader'
import { registrationService } from '@/_services/registration.service'
import { dobAboveTwentythree } from '@/_helpers/validators'
import { formatIncome } from '@/_helpers/transformers'
import SummaryExtraPeopleLine from '@/components/_registration/SummaryExtraPeopleLine'
import DisabledInputRow from '@/components/_registration/DisabledInputRow'
import dateTransformers from '@/mixins/dateTransformers'
import SummaryMessageBox from '@/components/_registration/SummaryMessageBox'

export default {
  components: { FormButtons, FormLoader, SummaryExtraPeopleLine, DisabledInputRow, SummaryMessageBox, formatIncome },
  name: 'Summary',
  mixins: [dateTransformers],
  data: () => {
    return {
      loading: false,
      summary: null,
      skin: {
        doorstromer: process.env.VUE_APP_DOORSTROMER === 'true',
        searchpoints: process.env.VUE_APP_SEARCHPOINTS === 'true',
        renewal: process.env.VUE_APP_PAYMENT_RECURRING === 'true',
        rightsName: process.env.VUE_APP_ALT_RIGHTS_NAME === undefined ? 'Zoekrecht' : process.env.VUE_APP_ALT_RIGHTS_NAME,
        oosztaan: process.env.VUE_APP_OOSTZAAN === 'true',
      }
    }
  },
  computed: {
    childrenUnder23 () {
      let children = []

      if (this.summary) {
        this.summary.extraPeople.info.forEach(function (person, index) {
          if (person.relation === 'Kind' && !dobAboveTwentythree(person.dob)) {
            children.push(person)
          }
        })
      }

      return children
    },
    childrenOver23 () {
      let children = []

      if (this.summary) {
        this.summary.extraPeople.info.forEach(function (person, index) {
          if (person.relation === 'Kind' && dobAboveTwentythree(person.dob)) {
            children.push(person)
          }
        })
      }

      return children
    },
    parents () {
      let parents = []

      if (this.summary) {
        this.summary.extraPeople.info.forEach(function (person, index) {
          if (person.relation === 'Ouder') {
            parents.push(person)
          }
        })
      }
      return parents
    },
    otherPeople () {
      let otherPeople = []

      if (this.summary) {
        this.summary.extraPeople.info.forEach(function (person, index) {
          if (person.relation !== 'Ouder' && person.relation !== 'Kind') {
            otherPeople.push(person)
          }
        })
      }

      return otherPeople
    },
  },
  methods: {
    fullName (person) {
      return [person.initials, person.between, person.lastname]
        .filter(part => part !== undefined && part !== null && `${part}`.trim() !== '')
        .join(' ')
    },
    fetchData () {
      this.loading = true
      registrationService.getSummary().then(result => {
        this.summary = result
        console.log(result)
        this.summary.grossincome = formatIncome(this.summary.grossincome)
      }).finally(() => {
        this.loading = false
      })
    }
  },
  mounted () {
    this.fetchData()
    this.$emit('validated', true)
  },
  activated () {
    this.fetchData()
  },
}
</script>
<style lang="scss" scoped>
.under23 {
  color: #009e0f;
  font-weight: bold;

}

.over23 {
  font-weight: bold;
}
</style>
